module.exports = __webpack_public_path__ + "img/43.c2931cd4.jpg";